module.exports = __webpack_public_path__ + "static/media/default_threads.628acc97.svg";